import { render } from "./PengaturanIzin.vue?vue&type=template&id=34a6e2f8"
import script from "./PengaturanIzin.vue?vue&type=script&lang=js"
export * from "./PengaturanIzin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__